/* Header account control (Customer-experience Cycle 1: Account entry).
 *
 * Logged out: the trigger is a plain <a> to /pages/login?next=<current
 * page>, server-rendered so it works with no JS at all; on load this script
 * rewrites the href to match svz-auth.js's own next-url convention exactly
 * (pathname + search, not just the path) rather than duplicating that logic
 * as a second implementation.
 *
 * Logged in (a valid existing svz-session -- see assets/svz-auth.js, the
 * SAME session /pages/account and the MTO wizard already use): the trigger
 * becomes a disclosure toggle for a small menu that deep-links into
 * /pages/account's own #orders/#projects/#vault tabs (svz-account.js
 * already supports this) and signs out via window.SvzAuth.logout(), the
 * exact function the account page's own Logout button already calls -- so
 * both places clear the session identically and land on the same homeUrl.
 *
 * No greeting name: the session-check response's shape (see svz-auth.js's
 * own header comment) has no confirmed display-name field, so this
 * deliberately never shows one rather than guessing at a field that might
 * not exist -- "My account" stays generic.
 */
(function () {
  var cfg = window.__SVZ_HEADER_ACCOUNT_CONFIG__ || {};
  var root = document.querySelector("[data-nav-account]");
  if (!root || !window.SvzAuth) return;

  var trigger = root.querySelector("[data-account-trigger]");
  var menu = root.querySelector("[data-account-menu]");
  var logoutBtn = root.querySelector("[data-account-logout]");

  if (trigger) {
    trigger.href = (cfg.loginUrl || "/pages/login") + "?next=" + encodeURIComponent(window.location.pathname + window.location.search);
  }

  function openMenu() {
    if (!menu || !trigger) return;
    menu.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
  }
  function closeMenu() {
    if (!menu || !trigger) return;
    menu.hidden = true;
    trigger.setAttribute("aria-expanded", "false");
  }

  function enableDropdown() {
    if (!trigger || !menu) return;
    trigger.setAttribute("aria-haspopup", "true");
    trigger.setAttribute("aria-expanded", "false");
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      if (menu.hidden) openMenu(); else closeMenu();
    });
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) closeMenu();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeMenu();
    });
  }

  if (logoutBtn) {
    logoutBtn.addEventListener("click", function () {
      window.SvzAuth.logout(cfg);
    });
  }

  var token = window.SvzAuth.getToken();
  if (!token) return; // stays the plain logged-out login link

  window.SvzAuth.api(cfg, { action: "session", token: token }).then(function (j) {
    if (!j || j.ok !== true) return; // stale/invalid token -- leave as the login link
    enableDropdown();
  }).catch(function () {
    // Could not confirm the session -- degrade to the safe logged-out link
    // rather than guessing; no error UI in the header for this.
  });
})();
